const VERIFIED_AT = '2026-11-02';
const GPT_5_6_VERIFIED_AT = '2026-11-02';
const GPT_6_1_VERIFIED_AT = '2026-11-02';
const CURRENT_AUDIT_VERIFIED_AT = '2026-11-02';
const OPENAI_MODELS_SOURCE = {
    label: 'OpenAI model docs',
    url: 'https://developers.openai.com/api/docs/models',
    verifiedAt: VERIFIED_AT
};
const OPENAI_ALL_MODELS_SOURCE = {
    label: 'OpenAI all-models list',
    url: 'https://developers.openai.com/api/docs/models/all',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const OPENAI_PRICING_SOURCE = {
    label: 'OpenAI pricing',
    url: 'https://developers.openai.com/api/docs/pricing',
    verifiedAt: VERIFIED_AT
};
const OPENAI_DEPRECATIONS_SOURCE = {
    label: 'OpenAI deprecations',
    url: 'https://developers.openai.com/api/docs/deprecations',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const OPENAI_CHANGELOG_SOURCE = {
    label: 'OpenAI API changelog',
    url: 'https://developers.openai.com/api/docs/changelog',
    verifiedAt: VERIFIED_AT
};
const OPENAI_LATEST_MODEL_GUIDE_SOURCE = {
    label: 'OpenAI latest model guide',
    url: 'https://developers.openai.com/api/docs/guides/latest-model',
    verifiedAt: VERIFIED_AT
};
const OPENAI_DEEP_RESEARCH_GUIDE_SOURCE = {
    label: 'OpenAI deep research guide',
    url: 'https://developers.openai.com/api/docs/guides/deep-research',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const OPENAI_PROMPT_CACHING_SOURCE = {
    label: 'OpenAI prompt caching',
    url: 'https://developers.openai.com/api/docs/guides/prompt-caching',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const OPENAI_CYBER_SAFETY_SOURCE = {
    label: 'OpenAI Daybreak models and Trusted Access',
    url: 'https://learn.chatgpt.com/docs/cyber-safety',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_MODELS_SOURCE = {
    label: 'Anthropic models overview',
    url: 'https://platform.claude.com/docs/en/models/overview',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const ANTHROPIC_PRICING_SOURCE = {
    label: 'Anthropic pricing',
    url: 'https://platform.claude.com/docs/en/about-claude/pricing',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_MODEL_DEPRECATIONS_SOURCE = {
    label: 'Anthropic model deprecations',
    url: 'https://platform.claude.com/docs/en/about-claude/model-deprecations',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const ANTHROPIC_MODEL_IDS_SOURCE = {
    label: 'Anthropic model IDs and versioning',
    url: 'https://platform.claude.com/docs/en/about-claude/models/model-ids-and-versions',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_RELEASE_NOTES_SOURCE = {
    label: 'Anthropic release notes',
    url: 'https://platform.claude.com/docs/en/release-notes/overview',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_MODELS_API_SOURCE = {
    label: 'Anthropic Models API capability metadata',
    url: 'https://platform.claude.com/docs/en/api/models/list',
    verifiedAt: CURRENT_AUDIT_VERIFIED_AT
};
const ANTHROPIC_FABLE_5_SOURCE = {
    label: 'Anthropic Claude Fable 5 model overview',
    url: 'https://platform.claude.com/docs/en/models/fable-5/overview',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_MIGRATION_GUIDE_SOURCE = {
    label: 'Anthropic Claude migration guide',
    url: 'https://platform.claude.com/docs/en/about-claude/models/migration-guide',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_OPUS_4_8_SOURCE = {
    label: 'Anthropic Claude Opus 4.8 launch notes',
    url: 'https://platform.claude.com/docs/en/about-claude/models/whats-new-claude-4-8',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_OPUS_5_SOURCE = {
    label: 'Anthropic Claude Opus 5 launch notes',
    url: 'https://platform.claude.com/docs/en/about-claude/models/whats-new-opus-5',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_OPUS_5_5_MIGRATION_SOURCE = {
    label: 'Anthropic Claude Opus 5.5 migration guide',
    url: 'https://platform.claude.com/docs/en/models/opus-5-5/migration-guide',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_SONNET_5_SOURCE = {
    label: 'Anthropic Claude Sonnet 5 launch notes',
    url: 'https://platform.claude.com/docs/en/about-claude/models/whats-new-sonnet-5',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_ADAPTIVE_THINKING_SOURCE = {
    label: 'Anthropic adaptive thinking',
    url: 'https://platform.claude.com/docs/en/build-with-claude/adaptive-thinking',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE = {
    label: 'Anthropic structured outputs',
    url: 'https://platform.claude.com/docs/en/build-with-claude/structured-outputs',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_WEB_SEARCH_SOURCE = {
    label: 'Anthropic web search tool',
    url: 'https://platform.claude.com/docs/en/agents-and-tools/tool-use/web-search-tool',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_COMPUTER_USE_SOURCE = {
    label: 'Anthropic computer use tool',
    url: 'https://platform.claude.com/docs/en/agents-and-tools/tool-use/computer-use-tool',
    verifiedAt: VERIFIED_AT
};
const ANTHROPIC_CONTEXT_WINDOWS_SOURCE = {
    label: 'Anthropic context windows',
    url: 'https://platform.claude.com/docs/en/build-with-claude/context-windows',
    verifiedAt: VERIFIED_AT
};
const OPENAI_GPT_6_REASONING_LEVELS = ['low', 'medium', 'high', 'xhigh', 'max'];
const OPENAI_GPT_6_REASONING_LEVELS_WITH_NONE = ['none', 'low', 'medium', 'high', 'xhigh', 'max'];
const OPENAI_GPT_5_6_REASONING_LEVELS = ['none', 'low', 'medium', 'high', 'xhigh', 'max'];
const OPENAI_GPT_5_5_REASONING_LEVELS = ['none', 'low', 'medium', 'high', 'xhigh'];
const OPENAI_GPT_5_4_REASONING_LEVELS = ['none', 'low', 'medium', 'high', 'xhigh'];
const OPENAI_GPT_5_1_REASONING_LEVELS = ['none', 'low', 'medium', 'high'];
const OPENAI_GPT_5_REASONING_LEVELS = ['minimal', 'low', 'medium', 'high'];
const OPENAI_GPT_PRO_REASONING_LEVELS = ['medium', 'high', 'xhigh'];
const OPENAI_GPT_CODEX_REASONING_LEVELS = ['low', 'medium', 'high', 'xhigh'];
const OPENAI_GPT_5_PARAMETER_POLICIES = {
    temperature: 'unsupported'
};
const OPENAI_GPT_5_1_PARAMETER_POLICIES = {
    temperature: 'requiresReasoningEffortNone'
};
const createPricing = (pricing) => pricing;
const createCapabilities = (capabilities) => capabilities;
const createOpenAiModelSource = (modelId, verifiedAt = VERIFIED_AT) => ({
    label: `OpenAI model doc: ${modelId}`,
    url: `https://developers.openai.com/api/docs/models/${modelId}`,
    verifiedAt
});
const createAnthropicModelSource = (modelSlug, verifiedAt = VERIFIED_AT) => ({
    label: `Anthropic model doc: claude-${modelSlug}`,
    url: `https://platform.claude.com/docs/en/models/${modelSlug}/overview`,
    verifiedAt
});
export const AI_MODEL_CATALOG = [
    {
        modelKey: 'openai:gpt-6-astra',
        provider: 'openai',
        modelId: 'gpt-6-astra',
        snapshotModelId: 'gpt-6-astra',
        aliases: [],
        displayName: 'GPT-6 Astra',
        family: 'gpt-6',
        description: 'OpenAI’s flagship model for complex reasoning, coding, computer use, research, and document creation.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_6_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-04-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 1,
            outputUsdPerMillionTokens: 50,
            cacheWriteUsdPerMillionTokens: 12.5,
            cacheWrite12hUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 20,
            longContextCachedInputUsdPerMillionTokens: 2,
            longContextCacheWriteUsdPerMillionTokens: 25,
            longContextCacheWrite12hUsdPerMillionTokens: 50,
            longContextOutputUsdPerMillionTokens: 75,
            notes: 'Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-6-astra'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['flagship', 'reasoning', 'coding', 'agent', 'research'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-6-sol',
        provider: 'openai',
        modelId: 'gpt-6-sol',
        snapshotModelId: 'gpt-6-sol',
        aliases: [],
        displayName: 'GPT-6 Sol',
        family: 'gpt-6',
        description: 'OpenAI model for complex coding and agentic workflows that balances intelligence and cost.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_6_REASONING_LEVELS_WITH_NONE,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-04-20',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.2,
            outputUsdPerMillionTokens: 10,
            cacheWriteUsdPerMillionTokens: 2.5,
            cacheWrite12hUsdPerMillionTokens: 5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 4,
            longContextCachedInputUsdPerMillionTokens: 0.4,
            longContextCacheWriteUsdPerMillionTokens: 5,
            longContextCacheWrite12hUsdPerMillionTokens: 10,
            longContextOutputUsdPerMillionTokens: 15,
            notes: 'Prompts above 272K input tokens are billed at 2x input and cache rates and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-6-sol'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_CHANGELOG_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'coding', 'agent', 'balanced', 'research'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-6.1-sol',
        provider: 'openai',
        modelId: 'gpt-6.1-sol',
        snapshotModelId: 'gpt-6.1-sol',
        aliases: [],
        displayName: 'GPT-6.1 Sol',
        family: 'gpt-6.1',
        description: 'OpenAI model with near-Astra performance for complex work at a lower cost.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_6_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-04-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.1,
            outputUsdPerMillionTokens: 10,
            cacheWriteUsdPerMillionTokens: 2.5,
            cacheWrite12hUsdPerMillionTokens: 5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 4,
            longContextCachedInputUsdPerMillionTokens: 0.2,
            longContextCacheWriteUsdPerMillionTokens: 5,
            longContextCacheWrite12hUsdPerMillionTokens: 10,
            longContextOutputUsdPerMillionTokens: 15,
            notes: 'Prompts above 272K input tokens are billed at 2x input and cache rates and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [OPENAI_PROMPT_CACHING_SOURCE, createOpenAiModelSource('gpt-6.1-sol', GPT_6_1_VERIFIED_AT)],
        tags: ['reasoning', 'coding', 'agent', 'balanced', 'research'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-6.1-terra',
        provider: 'openai',
        modelId: 'gpt-6.1-terra',
        snapshotModelId: 'gpt-6.1-terra',
        aliases: [],
        displayName: 'GPT-6.1 Terra',
        family: 'gpt-6.1',
        description: 'Fast, efficient OpenAI model for visual reasoning, precise computer use, and clear, natural writing.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_6_REASONING_LEVELS_WITH_NONE,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1,
            cachedInputUsdPerMillionTokens: 0.05,
            outputUsdPerMillionTokens: 5,
            cacheWriteUsdPerMillionTokens: 1.25,
            cacheWrite12hUsdPerMillionTokens: 2.5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 2,
            longContextCachedInputUsdPerMillionTokens: 0.1,
            longContextCacheWriteUsdPerMillionTokens: 2.5,
            longContextCacheWrite12hUsdPerMillionTokens: 5,
            longContextOutputUsdPerMillionTokens: 7.5,
            notes: 'Prompts above 272K input tokens are billed at 2x input and cache rates and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-6.1-terra', GPT_6_1_VERIFIED_AT),
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['reasoning', 'vision', 'computer-use', 'writing', 'balanced'],
        parameterPolicies: OPENAI_GPT_5_1_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-6-luna',
        provider: 'openai',
        modelId: 'gpt-6-luna',
        snapshotModelId: 'gpt-6-luna',
        aliases: [],
        displayName: 'GPT-6 Luna',
        family: 'gpt-6',
        description: 'OpenAI’s efficient GPT-6 model for focused, cost-sensitive, high-volume workloads.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_6_REASONING_LEVELS_WITH_NONE,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-05-18',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.1,
            cachedInputUsdPerMillionTokens: 0.01,
            outputUsdPerMillionTokens: 0.5,
            cacheWriteUsdPerMillionTokens: 0.125,
            cacheWrite12hUsdPerMillionTokens: 0.25,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 0.2,
            longContextCachedInputUsdPerMillionTokens: 0.02,
            longContextCacheWriteUsdPerMillionTokens: 0.25,
            longContextCacheWrite12hUsdPerMillionTokens: 0.5,
            longContextOutputUsdPerMillionTokens: 0.75,
            notes: 'Prompts above 272K input tokens are billed at 2x input and cache rates and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-6-luna'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_CHANGELOG_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'fast', 'cheap', 'high-volume'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.6-sol',
        provider: 'openai',
        modelId: 'gpt-5.6-sol',
        snapshotModelId: 'gpt-5.6-sol',
        aliases: ['gpt-5.6'],
        displayName: 'GPT-5.6 Sol',
        family: 'gpt-5.6',
        description: 'Frontier GPT-5.6 model for complex professional, coding, reasoning, and agentic workflows.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_6_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 4,
            cachedInputUsdPerMillionTokens: 0.4,
            outputUsdPerMillionTokens: 20,
            cacheWriteUsdPerMillionTokens: 5,
            cacheWrite12hUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 8,
            longContextCachedInputUsdPerMillionTokens: 0.8,
            longContextCacheWriteUsdPerMillionTokens: 10,
            longContextCacheWrite12hUsdPerMillionTokens: 20,
            longContextOutputUsdPerMillionTokens: 30,
            notes: 'Promotional pricing is available at least through November 21, 2026. Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-5.6-sol', GPT_5_6_VERIFIED_AT),
            createOpenAiModelSource('gpt-daybreak-blue-latest', GPT_5_6_VERIFIED_AT),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE,
            OPENAI_CYBER_SAFETY_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'coding', 'agent', 'flagship'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.6-cyber',
        provider: 'openai',
        modelId: 'gpt-5.6-cyber',
        snapshotModelId: 'gpt-5.6-cyber',
        aliases: [],
        displayName: 'GPT-5.6 Cyber',
        family: 'gpt-5.6',
        description: 'Restricted-access cybersecurity model for approved defenders conducting authorized vulnerability research, exploit validation, and security testing.',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 12.5,
            cachedInputUsdPerMillionTokens: 1.25,
            outputUsdPerMillionTokens: 75,
            cacheWriteUsdPerMillionTokens: 15.625,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 25,
            longContextCachedInputUsdPerMillionTokens: 2.5,
            longContextCacheWriteUsdPerMillionTokens: 31.25,
            longContextOutputUsdPerMillionTokens: 112.5,
            notes: 'Requires separate Daybreak approval and provisioning. Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full request. Cache writes are billed at 1.25x the uncached input rate.'
        }),
        sources: [
            createOpenAiModelSource('gpt-5.6-cyber', GPT_5_6_VERIFIED_AT),
            createOpenAiModelSource('gpt-daybreak-red-latest', GPT_5_6_VERIFIED_AT),
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_CYBER_SAFETY_SOURCE
        ],
        tags: ['specialized', 'reasoning', 'cybersecurity', 'restricted-access', 'agent']
    },
    {
        modelKey: 'openai:gpt-daybreak-blue-latest',
        provider: 'openai',
        modelId: 'gpt-daybreak-blue-latest',
        snapshotModelId: null,
        aliases: ['daybreak-blue-latest'],
        displayName: 'Daybreak Blue',
        family: 'daybreak',
        description: 'Deprecated Daybreak Blue alias retained for compatibility; use a stable model available to the approved organization.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 4,
            cachedInputUsdPerMillionTokens: 0.4,
            outputUsdPerMillionTokens: 20,
            cacheWriteUsdPerMillionTokens: 5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 8,
            longContextCachedInputUsdPerMillionTokens: 0.8,
            longContextCacheWriteUsdPerMillionTokens: 10,
            longContextOutputUsdPerMillionTokens: 30,
            notes: 'Alias rates follow its documented underlying snapshot; no independent alias prices or exact replacement ID are published. The replacement conservatively follows that snapshot without escalating access or cost tiers.'
        }),
        sources: [createOpenAiModelSource('gpt-daybreak-blue-latest'), createOpenAiModelSource('gpt-5.6-sol'), OPENAI_CYBER_SAFETY_SOURCE],
        tags: ['deprecated', 'cybersecurity', 'restricted-access', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-daybreak-red-latest',
        provider: 'openai',
        modelId: 'gpt-daybreak-red-latest',
        snapshotModelId: null,
        aliases: ['daybreak-red-latest'],
        displayName: 'Daybreak Red',
        family: 'daybreak',
        description: 'Deprecated Daybreak Red alias retained for compatibility; use a stable model available to the approved organization.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-cyber',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 12.5,
            cachedInputUsdPerMillionTokens: 1.25,
            outputUsdPerMillionTokens: 75,
            cacheWriteUsdPerMillionTokens: 15.625,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 25,
            longContextCachedInputUsdPerMillionTokens: 2.5,
            longContextCacheWriteUsdPerMillionTokens: 31.25,
            longContextOutputUsdPerMillionTokens: 112.5,
            notes: 'Alias rates follow its documented underlying snapshot; no independent alias prices or exact replacement ID are published. The replacement conservatively follows that snapshot without escalating access or cost tiers.'
        }),
        sources: [createOpenAiModelSource('gpt-daybreak-red-latest'), createOpenAiModelSource('gpt-5.6-cyber'), OPENAI_CYBER_SAFETY_SOURCE],
        tags: ['deprecated', 'cybersecurity', 'restricted-access', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-6-rosalind',
        provider: 'openai',
        modelId: 'gpt-6-rosalind',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-6 Rosalind',
        family: 'gpt-rosalind',
        description: 'Specialized biological reasoning with scientific tool use, restricted to approved internal life-sciences research.',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: null,
            supportsAudioInput: null,
            supportsAudioOutput: null,
            supportsVision: null,
            supportsStreaming: null,
            supportsToolCalling: null,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 15,
            cachedInputUsdPerMillionTokens: 1.5,
            outputUsdPerMillionTokens: 75,
            cacheWriteUsdPerMillionTokens: 18.75,
            cacheWrite12hUsdPerMillionTokens: 37.5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: 30,
            longContextCachedInputUsdPerMillionTokens: 3,
            longContextCacheWriteUsdPerMillionTokens: 37.5,
            longContextCacheWrite12hUsdPerMillionTokens: 75,
            longContextOutputUsdPerMillionTokens: 112.5,
            notes: 'Official pricing lists short- and long-context rates but no threshold. Cost estimates remain unavailable until the threshold is documented. Limits, snapshots, and feature support are not published on a per-model page. Access requires approval for internal life-sciences research.'
        }),
        sources: [OPENAI_PRICING_SOURCE, OPENAI_CHANGELOG_SOURCE],
        tags: ['specialized', 'reasoning', 'research', 'life-sciences', 'restricted-access']
    },
    {
        modelKey: 'openai:gpt-rosalind-research',
        provider: 'openai',
        modelId: 'gpt-rosalind-research',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-Rosalind',
        family: 'gpt-rosalind',
        description: 'Restricted-access life-sciences reasoning model for approved internal research.',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: null,
            supportsAudioInput: null,
            supportsAudioOutput: null,
            supportsVision: null,
            supportsStreaming: null,
            supportsToolCalling: null,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWriteUsdPerMillionTokens: null,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextCacheWriteUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Billing begins October 5, 2026. Cache-write pricing does not apply. Access is limited to approved internal research through the trusted-access program.'
        }),
        sources: [OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE, OPENAI_CHANGELOG_SOURCE],
        tags: ['specialized', 'reasoning', 'research', 'life-sciences', 'restricted-access']
    },
    {
        modelKey: 'openai:gpt-5.6-terra',
        provider: 'openai',
        modelId: 'gpt-5.6-terra',
        snapshotModelId: 'gpt-5.6-terra',
        aliases: [],
        displayName: 'GPT-5.6 Terra',
        family: 'gpt-5.6',
        description: 'GPT-5.6 model that balances intelligence and cost for broad production workloads.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_6_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.2,
            outputUsdPerMillionTokens: 12,
            cacheWriteUsdPerMillionTokens: 2.5,
            cacheWrite12hUsdPerMillionTokens: 5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 4,
            longContextCachedInputUsdPerMillionTokens: 0.4,
            longContextCacheWriteUsdPerMillionTokens: 5,
            longContextCacheWrite12hUsdPerMillionTokens: 10,
            longContextOutputUsdPerMillionTokens: 18,
            notes: 'Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-5.6-terra', GPT_5_6_VERIFIED_AT),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'balanced', 'coding', 'agent'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.6-luna',
        provider: 'openai',
        modelId: 'gpt-5.6-luna',
        snapshotModelId: 'gpt-5.6-luna',
        aliases: [],
        displayName: 'GPT-5.6 Luna',
        family: 'gpt-5.6',
        description: 'Cost-sensitive GPT-5.6 model for efficient, high-volume production workloads.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_6_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-02-16',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.2,
            cachedInputUsdPerMillionTokens: 0.02,
            outputUsdPerMillionTokens: 1.2,
            cacheWriteUsdPerMillionTokens: 0.25,
            cacheWrite12hUsdPerMillionTokens: 0.5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 0.4,
            longContextCachedInputUsdPerMillionTokens: 0.04,
            longContextCacheWriteUsdPerMillionTokens: 0.5,
            longContextCacheWrite12hUsdPerMillionTokens: 1,
            longContextOutputUsdPerMillionTokens: 1.8,
            notes: 'Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full request. Responses API cache writes cost 1.25x input for the default 30m retention and 2.5x input for optional 12h retention.'
        }),
        sources: [
            OPENAI_PROMPT_CACHING_SOURCE,
            createOpenAiModelSource('gpt-5.6-luna', GPT_5_6_VERIFIED_AT),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'fast', 'cheap', 'high-volume'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.5',
        provider: 'openai',
        modelId: 'gpt-5.5',
        snapshotModelId: 'gpt-5.5-2026-04-23',
        aliases: ['gpt-5.5-2026-04-23'],
        displayName: 'GPT-5.5',
        family: 'gpt-5.5',
        description: 'OpenAI flagship model for complex reasoning, coding, agentic, and professional workflows.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_5_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-12-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 30,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 10,
            longContextCachedInputUsdPerMillionTokens: 1,
            longContextOutputUsdPerMillionTokens: 45,
            notes: 'Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full session.'
        }),
        sources: [
            createOpenAiModelSource('gpt-5.5'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'coding', 'agent'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.5-pro',
        provider: 'openai',
        modelId: 'gpt-5.5-pro',
        snapshotModelId: 'gpt-5.5-pro-2026-04-23',
        aliases: ['gpt-5.5-pro-2026-04-23'],
        displayName: 'GPT-5.5 pro',
        family: 'gpt-5.5',
        description: 'More precise GPT-5.5 variant for tough problems. Responses API requests may take minutes to finish (consider background mode).',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: false,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: false,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_PRO_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-12-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 30,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: 180,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 60,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: 270,
            notes: 'Pricing page does not list cached-input token rates for GPT-5.5 pro. Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full session.'
        }),
        sources: [
            createOpenAiModelSource('gpt-5.5-pro'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['specialized', 'reasoning', 'slow', 'expensive', 'responses-only'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.4',
        provider: 'openai',
        modelId: 'gpt-5.4',
        snapshotModelId: 'gpt-5.4-2026-03-05',
        aliases: ['gpt-5.4-2026-03-05'],
        displayName: 'GPT-5.4',
        family: 'gpt-5.4',
        description: 'OpenAI flagship model for complex reasoning, coding, and professional workflows.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_4_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2.5,
            cachedInputUsdPerMillionTokens: 0.25,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 5,
            longContextCachedInputUsdPerMillionTokens: 0.5,
            longContextOutputUsdPerMillionTokens: 22.5,
            notes: 'Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full session.'
        }),
        sources: [createOpenAiModelSource('gpt-5.4'), OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE],
        tags: ['recommended', 'reasoning', 'coding', 'agent'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.4-cyber',
        provider: 'openai',
        modelId: 'gpt-5.4-cyber',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.4 Cyber',
        family: 'gpt-5.4',
        description: 'Retired restricted-access cybersecurity model from the OpenAI Daybreak program (shut down October 1, 2026).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-cyber',
        inputModalities: ['text'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: null,
            supportsAudioInput: null,
            supportsAudioOutput: null,
            supportsVision: null,
            supportsStreaming: null,
            supportsToolCalling: null,
            supportsStructuredOutputs: null,
            supportsPromptCaching: null,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: null,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: null,
            cacheWriteUsdPerMillionTokens: null,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextCacheWriteUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Deprecated September 11, 2026 and scheduled for API removal October 1, 2026. Official current documentation does not publish retained model specifications or pricing.'
        }),
        sources: [OPENAI_DEPRECATIONS_SOURCE, OPENAI_CYBER_SAFETY_SOURCE],
        tags: ['specialized', 'reasoning', 'cybersecurity', 'restricted-access'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.4-pro',
        provider: 'openai',
        modelId: 'gpt-5.4-pro',
        snapshotModelId: 'gpt-5.4-pro-2026-03-05',
        aliases: ['gpt-5.4-pro-2026-03-05'],
        displayName: 'GPT-5.4 pro',
        family: 'gpt-5.4',
        description: 'More precise GPT-5.4 variant for tough problems. Responses API only; may take minutes to finish (consider background mode).',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: false,
            supportsPromptCaching: false,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_PRO_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_050_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 30,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: 180,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: 272_000,
            longContextInputUsdPerMillionTokens: 60,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: 270,
            notes: 'Pricing page does not list cached-input token rates for GPT-5.4 pro. Prompts above 272K input tokens are billed at 2x input and 1.5x output for the full session.'
        }),
        sources: [createOpenAiModelSource('gpt-5.4-pro'), OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE],
        tags: ['specialized', 'reasoning', 'slow', 'expensive', 'responses-only'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.4-mini',
        provider: 'openai',
        modelId: 'gpt-5.4-mini',
        snapshotModelId: 'gpt-5.4-mini-2026-03-17',
        aliases: ['gpt-5.4-mini-2026-03-17'],
        displayName: 'GPT-5.4 mini',
        family: 'gpt-5.4',
        description: 'Faster, lower-cost GPT-5.4 variant for high-volume agent and coding workloads.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: true,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_4_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.75,
            cachedInputUsdPerMillionTokens: 0.075,
            outputUsdPerMillionTokens: 4.5,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [createOpenAiModelSource('gpt-5.4-mini'), OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE],
        tags: ['recommended', 'fast', 'balanced', 'coding', 'agent'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.4-nano',
        provider: 'openai',
        modelId: 'gpt-5.4-nano',
        snapshotModelId: 'gpt-5.4-nano-2026-03-17',
        aliases: ['gpt-5.4-nano-2026-03-17'],
        displayName: 'GPT-5.4 nano',
        family: 'gpt-5.4',
        description: 'Lowest-cost GPT-5.4-class model for simple high-volume workloads and sub-agents.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_4_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.2,
            cachedInputUsdPerMillionTokens: 0.02,
            outputUsdPerMillionTokens: 1.25,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5.4-nano', CURRENT_AUDIT_VERIFIED_AT),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['deprecated', 'cheap', 'classifier', 'subagent', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:chat-latest',
        provider: 'openai',
        modelId: 'chat-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'Chat Latest',
        family: 'chat-latest',
        description: 'Latest ChatGPT Instant model alias for ChatGPT-style integrations; OpenAI recommends GPT-6 Astra for production API use.',
        status: 'active',
        recommendedReplacementModelKey: 'openai:gpt-6-astra',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 30,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'OpenAI recommends GPT-6 Astra for production API use when a stable model ID is preferable to the ChatGPT latest alias.'
        }),
        sources: [
            createOpenAiModelSource('chat-latest'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_LATEST_MODEL_GUIDE_SOURCE
        ],
        tags: ['active', 'alias', 'chat', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.3-chat-latest',
        provider: 'openai',
        modelId: 'gpt-5.3-chat-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.3 Chat (latest)',
        family: 'gpt-5.3',
        description: 'Retired chat-oriented GPT-5.3 Instant model retained for compatibility with older ChatGPT-style integrations.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.75,
            cachedInputUsdPerMillionTokens: 0.175,
            outputUsdPerMillionTokens: 14,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5.3-chat-latest'),
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['deprecated', 'alias', 'chat', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.3-codex',
        provider: 'openai',
        modelId: 'gpt-5.3-codex',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.3-Codex',
        family: 'gpt-5.3-codex',
        description: 'OpenAI model optimized for agentic coding tasks in Codex and similar environments.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_CODEX_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.75,
            cachedInputUsdPerMillionTokens: 0.175,
            outputUsdPerMillionTokens: 14,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5.3-codex', CURRENT_AUDIT_VERIFIED_AT),
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['deprecated', 'coding', 'agent', 'codex', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.2-codex',
        provider: 'openai',
        modelId: 'gpt-5.2-codex',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.2-Codex',
        family: 'gpt-5.2-codex',
        description: 'Retired GPT-5.2 coding model retained for downstream compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_CODEX_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.75,
            cachedInputUsdPerMillionTokens: 0.175,
            outputUsdPerMillionTokens: 14,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [createOpenAiModelSource('gpt-5.2-codex'), OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE, OPENAI_DEPRECATIONS_SOURCE],
        tags: ['retired', 'coding', 'codex', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.2',
        provider: 'openai',
        modelId: 'gpt-5.2',
        snapshotModelId: 'gpt-5.2-2025-12-11',
        aliases: ['gpt-5.2-2025-12-11'],
        displayName: 'GPT-5.2',
        family: 'gpt-5.2',
        description: 'Previous frontier GPT-5 model still useful for compatibility while migrating to GPT-5.6 Sol.',
        status: 'legacy',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_4_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.75,
            cachedInputUsdPerMillionTokens: 0.175,
            outputUsdPerMillionTokens: 14,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [createOpenAiModelSource('gpt-5.2'), OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE],
        tags: ['legacy', 'reasoning', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.2-pro',
        provider: 'openai',
        modelId: 'gpt-5.2-pro',
        snapshotModelId: 'gpt-5.2-pro-2025-12-11',
        aliases: ['gpt-5.2-pro-2025-12-11'],
        displayName: 'GPT-5.2 pro',
        family: 'gpt-5.2',
        description: 'Older pro GPT-5.2 variant for tough problems. Responses API only; may take minutes to finish (consider background mode).',
        status: 'legacy',
        recommendedReplacementModelKey: 'openai:gpt-5.5-pro',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: false,
            supportsPromptCaching: false,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_PRO_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 21,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: 168,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Pricing page does not list cached-input token rates for GPT-5.2 pro.'
        }),
        sources: [createOpenAiModelSource('gpt-5.2-pro'), OPENAI_MODELS_SOURCE, OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE],
        tags: ['legacy', 'reasoning', 'slow', 'expensive', 'responses-only'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.2-chat-latest',
        provider: 'openai',
        modelId: 'gpt-5.2-chat-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.2 Chat (latest)',
        family: 'gpt-5.2',
        description: 'Retired chat-oriented GPT-5.2 model used in ChatGPT, kept mainly for compatibility with older integrations.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2025-08-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.75,
            cachedInputUsdPerMillionTokens: 0.175,
            outputUsdPerMillionTokens: 14,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Alias pricing matches GPT-5.2.'
        }),
        sources: [
            createOpenAiModelSource('gpt-5.2-chat-latest'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['deprecated', 'alias', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.1',
        provider: 'openai',
        modelId: 'gpt-5.1',
        snapshotModelId: 'gpt-5.1-2025-11-13',
        aliases: ['gpt-5.1-2025-11-13'],
        displayName: 'GPT-5.1',
        family: 'gpt-5.1',
        description: 'Older GPT-5 generation kept for migrations and backward compatibility.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_1_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5.1', CURRENT_AUDIT_VERIFIED_AT),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['deprecated', 'reasoning', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_1_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.1-chat-latest',
        provider: 'openai',
        modelId: 'gpt-5.1-chat-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.1 Chat (latest)',
        family: 'gpt-5.1',
        description: 'Retired chat-oriented GPT-5.1 model retained for compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5.1-chat-latest'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'alias', 'chat', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_1_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.1-codex',
        provider: 'openai',
        modelId: 'gpt-5.1-codex',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.1 Codex',
        family: 'gpt-5.1-codex',
        description: 'Retired GPT-5.1 coding model retained for downstream compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: true,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'OpenAI docs do not list explicit reasoning-effort levels for this deprecated Codex model.'
        }),
        sources: [createOpenAiModelSource('gpt-5.1-codex'), OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE, OPENAI_DEPRECATIONS_SOURCE],
        tags: ['retired', 'coding', 'codex', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5.1-codex-mini',
        provider: 'openai',
        modelId: 'gpt-5.1-codex-mini',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5.1 Codex mini',
        family: 'gpt-5.1-codex',
        description: 'Retired smaller GPT-5.1 Codex model retained for downstream compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-terra',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: true,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.25,
            cachedInputUsdPerMillionTokens: 0.025,
            outputUsdPerMillionTokens: 2,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'OpenAI docs do not list explicit reasoning-effort levels for this deprecated Codex model.'
        }),
        sources: [
            createOpenAiModelSource('gpt-5.1-codex-mini'),
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'coding', 'cheap', 'codex', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5',
        provider: 'openai',
        modelId: 'gpt-5',
        snapshotModelId: 'gpt-5-2025-08-07',
        aliases: ['gpt-5-2025-08-07'],
        displayName: 'GPT-5',
        family: 'gpt-5',
        description: 'Previous GPT-5 model for reasoning and agentic tasks across domains.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The current snapshot is deprecated and scheduled to shut down on December 11, 2026; the alias follows that snapshot. Retained for compatibility.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-5'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'reasoning', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5-codex',
        provider: 'openai',
        modelId: 'gpt-5-codex',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5-Codex',
        family: 'gpt-5-codex',
        description: 'Retired GPT-5 coding model retained for downstream compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: true,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'OpenAI docs do not list explicit reasoning-effort levels for this deprecated Codex model.'
        }),
        sources: [createOpenAiModelSource('gpt-5-codex'), OPENAI_ALL_MODELS_SOURCE, OPENAI_PRICING_SOURCE, OPENAI_DEPRECATIONS_SOURCE],
        tags: ['retired', 'coding', 'codex', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5-chat-latest',
        provider: 'openai',
        modelId: 'gpt-5-chat-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'GPT-5 Chat (latest)',
        family: 'gpt-5',
        description: 'Retired chat-oriented GPT-5 model retained for compatibility (requests now fail on the OpenAI API).',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2024-09-30',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.25,
            cachedInputUsdPerMillionTokens: 0.125,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('gpt-5-chat-latest'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'alias', 'chat', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5-mini',
        provider: 'openai',
        modelId: 'gpt-5-mini',
        snapshotModelId: 'gpt-5-mini-2025-08-07',
        aliases: ['gpt-5-mini-2025-08-07'],
        displayName: 'GPT-5 mini',
        family: 'gpt-5',
        description: 'Lower-cost GPT-5 model kept for compatibility with existing low-latency workloads.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-terra',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-05-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.25,
            cachedInputUsdPerMillionTokens: 0.025,
            outputUsdPerMillionTokens: 2,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The current snapshot is deprecated and scheduled to shut down on December 11, 2026; the alias follows that snapshot. Retained for compatibility.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-5-mini'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'fast', 'cheap', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-5-nano',
        provider: 'openai',
        modelId: 'gpt-5-nano',
        snapshotModelId: 'gpt-5-nano-2025-08-07',
        aliases: ['gpt-5-nano-2025-08-07'],
        displayName: 'GPT-5 nano',
        family: 'gpt-5',
        description: 'Previous ultra-cheap GPT-5 model retained for small background tasks and compatibility.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: true,
            reasoningEffortLevels: OPENAI_GPT_5_REASONING_LEVELS,
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 400_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2024-05-31',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.05,
            cachedInputUsdPerMillionTokens: 0.005,
            outputUsdPerMillionTokens: 0.4,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The current snapshot is deprecated and scheduled to shut down on December 11, 2026; the alias follows that snapshot. Retained for compatibility.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-5-nano'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'cheap', 'background', 'compatibility'],
        parameterPolicies: OPENAI_GPT_5_PARAMETER_POLICIES
    },
    {
        modelKey: 'openai:gpt-4.1',
        provider: 'openai',
        modelId: 'gpt-4.1',
        snapshotModelId: 'gpt-4.1-2025-04-14',
        aliases: ['gpt-4.1-2025-04-14'],
        displayName: 'GPT-4.1',
        family: 'gpt-4.1',
        description: 'Deprecated non-reasoning OpenAI model retained for compatibility until its January 14, 2027 shutdown.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_047_576,
        maxOutputTokens: 32_768,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 8,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Deprecated October 14, 2026; the current snapshot shuts down January 14, 2027. The unpinned alias follows that snapshot. Earlier snapshots may have earlier shutdowns.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-4.1'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'tooling', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-4.1-mini',
        provider: 'openai',
        modelId: 'gpt-4.1-mini',
        snapshotModelId: 'gpt-4.1-mini-2025-04-14',
        aliases: ['gpt-4.1-mini-2025-04-14'],
        displayName: 'GPT-4.1 mini',
        family: 'gpt-4.1',
        description: 'Deprecated smaller GPT-4.1 model retained for compatibility until its January 14, 2027 shutdown.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_047_576,
        maxOutputTokens: 32_768,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.4,
            cachedInputUsdPerMillionTokens: 0.1,
            outputUsdPerMillionTokens: 1.6,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Deprecated October 14, 2026; the current snapshot shuts down January 14, 2027. The unpinned alias follows that snapshot. Earlier snapshots may have earlier shutdowns.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-4.1-mini'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'fast', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-4.1-nano',
        provider: 'openai',
        modelId: 'gpt-4.1-nano',
        snapshotModelId: 'gpt-4.1-nano-2025-04-14',
        aliases: ['gpt-4.1-nano-2025-04-14'],
        displayName: 'GPT-4.1 nano',
        family: 'gpt-4.1',
        description: 'Retired smallest GPT-4.1 variant retained for compatibility and very low-latency tasks.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: false,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 1_047_576,
        maxOutputTokens: 32_768,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.1,
            cachedInputUsdPerMillionTokens: 0.025,
            outputUsdPerMillionTokens: 0.4,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Retired October 23, 2026. Historical limits and rates remain available for persisted records; live requests automatically use the same-provider replacement.'
        }),
        sources: [
            createOpenAiModelSource('gpt-4.1-nano'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'cheap', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-4o',
        provider: 'openai',
        modelId: 'gpt-4o',
        snapshotModelId: 'gpt-4o-2024-08-06',
        aliases: ['gpt-4o-2024-11-20', 'gpt-4o-2024-08-06'],
        displayName: 'GPT-4o',
        family: 'gpt-4o',
        description: 'Deprecated multimodal GPT model retained for compatibility until its January 14, 2027 shutdown.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2023-10-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2.5,
            cachedInputUsdPerMillionTokens: 1.25,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Deprecated October 14, 2026; the current snapshot shuts down January 14, 2027. The unpinned alias follows that snapshot. Earlier snapshots may have earlier shutdowns.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-4o'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'multimodal', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-4o-2024-05-13',
        provider: 'openai',
        modelId: 'gpt-4o-2024-05-13',
        snapshotModelId: 'gpt-4o-2024-05-13',
        aliases: [],
        displayName: 'GPT-4o (May 2024 snapshot)',
        family: 'gpt-4o',
        description: 'Retired initial GPT-4o snapshot retained separately for historical pricing and replacement routing.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: null,
            supportsToolCalling: null,
            supportsStructuredOutputs: null,
            supportsPromptCaching: null,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Retired October 23, 2026. Pricing is published for this snapshot; current per-model documentation only specifies limits and tool support for the later GPT-4o snapshot, so those historical fields remain unknown.'
        }),
        sources: [OPENAI_DEPRECATIONS_SOURCE, createOpenAiModelSource('gpt-4o'), OPENAI_PRICING_SOURCE],
        tags: ['retired', 'snapshot', 'compatibility']
    },
    {
        modelKey: 'openai:chatgpt-4o-latest',
        provider: 'openai',
        modelId: 'chatgpt-4o-latest',
        snapshotModelId: null,
        aliases: [],
        displayName: 'ChatGPT-4o (latest)',
        family: 'gpt-4o',
        description: 'Retired ChatGPT-4o model snapshot retained for compatibility with apps that still reference this model id directly.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.1-chat-latest',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: false,
            supportsStructuredOutputs: false,
            supportsPromptCaching: false,
            supportsWebSearch: false,
            supportsFileSearch: false,
            supportsComputerUse: false,
            supportsMcp: false,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2023-10-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'OpenAI deprecations list removal from the API on 2026-02-17; retained for ID resolution only.'
        }),
        sources: [
            createOpenAiModelSource('chatgpt-4o-latest'),
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'chat', 'compatibility']
    },
    {
        modelKey: 'openai:gpt-4o-mini',
        provider: 'openai',
        modelId: 'gpt-4o-mini',
        snapshotModelId: 'gpt-4o-mini-2024-07-18',
        aliases: ['gpt-4o-mini-2024-07-18'],
        displayName: 'GPT-4o mini',
        family: 'gpt-4o',
        description: 'Deprecated smaller GPT-4o model retained for compatibility until its January 14, 2027 shutdown.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-6-luna',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 128_000,
        maxOutputTokens: 16_384,
        knowledgeCutoff: '2023-10-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.15,
            cachedInputUsdPerMillionTokens: 0.075,
            outputUsdPerMillionTokens: 0.6,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Deprecated October 14, 2026; the current snapshot shuts down January 14, 2027. The unpinned alias follows that snapshot.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('gpt-4o-mini'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'cheap', 'compatibility']
    },
    {
        modelKey: 'openai:o1',
        provider: 'openai',
        modelId: 'o1',
        snapshotModelId: 'o1-2024-12-17',
        aliases: ['o1-2024-12-17'],
        displayName: 'o1',
        family: 'o1',
        description: 'Retired full o-series reasoning model retained for compatibility.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: false,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2023-10-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 15,
            cachedInputUsdPerMillionTokens: 7.5,
            outputUsdPerMillionTokens: 60,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Retired October 23, 2026. Historical limits and rates remain available for persisted records; live requests automatically use the same-provider replacement.'
        }),
        sources: [
            createOpenAiModelSource('o1'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'openai:o3',
        provider: 'openai',
        modelId: 'o3',
        snapshotModelId: 'o3-2025-04-16',
        aliases: ['o3-2025-04-16'],
        displayName: 'o3',
        family: 'o3',
        description: 'Legacy reasoning model for complex tasks, succeeded by GPT-5.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 8,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The current snapshot is deprecated and scheduled to shut down on December 11, 2026; the alias follows that snapshot. Retained for compatibility.'
        }),
        sources: [
            OPENAI_DEPRECATIONS_SOURCE,
            createOpenAiModelSource('o3'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE
        ],
        tags: ['deprecated', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'openai:o3-mini',
        provider: 'openai',
        modelId: 'o3-mini',
        snapshotModelId: 'o3-mini-2025-01-31',
        aliases: ['o3-mini-2025-01-31'],
        displayName: 'o3-mini',
        family: 'o3',
        description: 'Retired small reasoning model retained for compatibility.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: false,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: false,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: false,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2023-10-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.1,
            cachedInputUsdPerMillionTokens: 0.55,
            outputUsdPerMillionTokens: 4.4,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Retired October 23, 2026. Historical limits and rates remain available for persisted records; live requests automatically use the same-provider replacement.'
        }),
        sources: [
            createOpenAiModelSource('o3-mini'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'reasoning', 'cheap', 'compatibility']
    },
    {
        modelKey: 'openai:o4-mini',
        provider: 'openai',
        modelId: 'o4-mini',
        snapshotModelId: 'o4-mini-2025-04-16',
        aliases: ['o4-mini-2025-04-16'],
        displayName: 'o4-mini',
        family: 'o4',
        description: 'Retired small reasoning model retained for compatibility.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-terra',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1.1,
            cachedInputUsdPerMillionTokens: 0.275,
            outputUsdPerMillionTokens: 4.4,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Retired October 23, 2026. Historical limits and rates remain available for persisted records; live requests automatically use the same-provider replacement.'
        }),
        sources: [
            createOpenAiModelSource('o4-mini'),
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'reasoning', 'cheap', 'compatibility']
    },
    {
        modelKey: 'openai:o3-deep-research',
        provider: 'openai',
        modelId: 'o3-deep-research',
        snapshotModelId: null,
        aliases: [],
        displayName: 'o3 Deep Research',
        family: 'o3-deep-research',
        description: 'Retired dedicated deep-research alias retained for historical requests and cost records.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: false,
            supportsStructuredOutputs: false,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 2.5,
            outputUsdPerMillionTokens: 40,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('o3-deep-research', CURRENT_AUDIT_VERIFIED_AT),
            OPENAI_DEEP_RESEARCH_GUIDE_SOURCE,
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'deep-research', 'search', 'compatibility']
    },
    {
        modelKey: 'openai:o3-deep-research-2025-06-26',
        provider: 'openai',
        modelId: 'o3-deep-research-2025-06-26',
        snapshotModelId: null,
        aliases: [],
        displayName: 'o3 Deep Research (2025-06-26)',
        family: 'o3-deep-research',
        description: 'Retired pinned deep-research snapshot kept for compatibility with apps that reference this model ID directly.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:o3-deep-research',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: false,
            supportsStructuredOutputs: false,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 2.5,
            outputUsdPerMillionTokens: 40,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('o3-deep-research'),
            OPENAI_DEEP_RESEARCH_GUIDE_SOURCE,
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'deep-research', 'compatibility']
    },
    {
        modelKey: 'openai:o4-mini-deep-research',
        provider: 'openai',
        modelId: 'o4-mini-deep-research',
        snapshotModelId: null,
        aliases: [],
        displayName: 'o4-mini Deep Research',
        family: 'o4-mini-deep-research',
        description: 'Retired lower-cost dedicated deep-research alias retained for historical requests and cost records.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:gpt-5.6-sol',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: false,
            supportsStructuredOutputs: false,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 8,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('o4-mini-deep-research', CURRENT_AUDIT_VERIFIED_AT),
            OPENAI_DEEP_RESEARCH_GUIDE_SOURCE,
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'deep-research', 'fast', 'search', 'compatibility']
    },
    {
        modelKey: 'openai:o4-mini-deep-research-2025-06-26',
        provider: 'openai',
        modelId: 'o4-mini-deep-research-2025-06-26',
        snapshotModelId: null,
        aliases: [],
        displayName: 'o4-mini Deep Research (2025-06-26)',
        family: 'o4-mini-deep-research',
        description: 'Retired pinned deep-research snapshot kept for compatibility with apps that reference this model ID directly.',
        status: 'retired',
        recommendedReplacementModelKey: 'openai:o4-mini-deep-research',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: false,
            supportsStructuredOutputs: false,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: true,
            supportsComputerUse: null,
            supportsMcp: true,
            supportsReasoningEffort: null,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 100_000,
        knowledgeCutoff: '2024-06-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 8,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            createOpenAiModelSource('o4-mini-deep-research'),
            OPENAI_DEEP_RESEARCH_GUIDE_SOURCE,
            OPENAI_MODELS_SOURCE,
            OPENAI_ALL_MODELS_SOURCE,
            OPENAI_PRICING_SOURCE,
            OPENAI_DEPRECATIONS_SOURCE
        ],
        tags: ['retired', 'deep-research', 'fast', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-fable-5-1',
        provider: 'anthropic',
        modelId: 'claude-fable-5-1',
        snapshotModelId: 'claude-fable-5-1',
        aliases: [],
        displayName: 'Claude Fable 5.1',
        family: 'claude-fable-5.1',
        description: 'Anthropic’s latest Fable model for demanding reasoning, coding, and long-horizon agentic work.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 0.25,
            outputUsdPerMillionTokens: 50,
            cacheWrite5mUsdPerMillionTokens: 12.5,
            cacheWrite1hUsdPerMillionTokens: 20,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context window is included at standard pricing. Claude Fable 5.1 uses 30-day data retention and is not available under zero data retention unless Anthropic has authorized an exception.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('fable-5-1'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['latest', 'reasoning', 'coding', 'agent'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-mythos-5-1',
        provider: 'anthropic',
        modelId: 'claude-mythos-5-1',
        snapshotModelId: 'claude-mythos-5-1',
        aliases: [],
        displayName: 'Claude Mythos 5.1',
        family: 'claude-mythos-5.1',
        description: 'Invite-only Project Glasswing model with Claude Fable 5.1 capabilities and modified safety classifications.',
        status: 'specialized',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 0.25,
            outputUsdPerMillionTokens: 50,
            cacheWrite5mUsdPerMillionTokens: 12.5,
            cacheWrite1hUsdPerMillionTokens: 20,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Invite-only availability through Project Glasswing. Full 1M context window is included at standard pricing. Claude Mythos 5.1 uses 30-day data retention and is not available under zero data retention unless Anthropic has authorized an exception.'
        }),
        sources: [
            createAnthropicModelSource('mythos-5-1'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['latest', 'specialized', 'reasoning', 'coding', 'agent', 'limited-availability'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-fable-5',
        provider: 'anthropic',
        modelId: 'claude-fable-5',
        snapshotModelId: 'claude-fable-5',
        aliases: [],
        displayName: 'Claude Fable 5',
        family: 'claude-fable-5',
        description: 'Legacy Fable model retained for compatibility while integrations migrate to Claude Fable 5.1.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-fable-5-1',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 1,
            outputUsdPerMillionTokens: 50,
            cacheWrite5mUsdPerMillionTokens: 12.5,
            cacheWrite1hUsdPerMillionTokens: 20,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context window is included at standard pricing. Claude Fable 5 requires 30-day data retention and is not available under zero data retention.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('fable-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_FABLE_5_SOURCE,
            ANTHROPIC_MIGRATION_GUIDE_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'coding', 'agent'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-mythos-5',
        provider: 'anthropic',
        modelId: 'claude-mythos-5',
        snapshotModelId: 'claude-mythos-5',
        aliases: [],
        displayName: 'Claude Mythos 5',
        family: 'claude-mythos-5',
        description: 'Limited-availability Project Glasswing model with Claude Fable 5 capabilities and no Fable safety classifiers.',
        status: 'specialized',
        recommendedReplacementModelKey: 'anthropic:claude-mythos-5-1',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 10,
            cachedInputUsdPerMillionTokens: 1,
            outputUsdPerMillionTokens: 50,
            cacheWrite5mUsdPerMillionTokens: 12.5,
            cacheWrite1hUsdPerMillionTokens: 20,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Limited availability through Project Glasswing. Full 1M context window is included at standard pricing. Claude Mythos 5 requires 30-day data retention and is not available under zero data retention.'
        }),
        sources: [
            createAnthropicModelSource('mythos-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_FABLE_5_SOURCE,
            ANTHROPIC_MIGRATION_GUIDE_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['specialized', 'reasoning', 'coding', 'agent', 'limited-availability'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-mythos-preview',
        provider: 'anthropic',
        modelId: 'claude-mythos-preview',
        snapshotModelId: 'claude-mythos-preview',
        aliases: [],
        displayName: 'Claude Mythos Preview',
        family: 'claude-mythos',
        description: 'Deprecated invitation-only Project Glasswing research preview retained for compatibility until retirement.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'anthropic:claude-mythos-5-1',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: true
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: null,
            cachedInputUsdPerMillionTokens: null,
            outputUsdPerMillionTokens: null,
            cacheWrite5mUsdPerMillionTokens: null,
            cacheWrite1hUsdPerMillionTokens: null,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Anthropic documents prompt-caching and standard-rate 1M-context support but does not publish base token rates for this gated preview.'
        }),
        sources: [
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_MIGRATION_GUIDE_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_CONTEXT_WINDOWS_SOURCE
        ],
        tags: ['deprecated', 'reasoning', 'agent', 'specialized', 'limited-availability', 'compatibility'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-opus-5-5',
        provider: 'anthropic',
        modelId: 'claude-opus-5-5',
        snapshotModelId: 'claude-opus-5-5',
        aliases: [],
        displayName: 'Claude Opus 5.5',
        family: 'claude-opus-5',
        description: 'Anthropic’s current Opus model for long-running agentic coding and knowledge work.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false,
            requiresAdaptiveThinking: true
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06',
        pricing: createPricing({
            inputUsdPerMillionTokens: 4,
            cachedInputUsdPerMillionTokens: 0.2,
            outputUsdPerMillionTokens: 20,
            cacheWrite5mUsdPerMillionTokens: 5,
            cacheWrite1hUsdPerMillionTokens: 8,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context is included at standard pricing. Adaptive thinking is always on and is controlled with the effort parameter; legacy manual and disabled thinking configurations are rejected.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('opus-5-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_OPUS_5_5_MIGRATION_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['recommended', 'reasoning', 'coding', 'agent'],
        parameterPolicies: {
            temperature: 'unsupported',
            forcedToolChoice: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-opus-5',
        provider: 'anthropic',
        modelId: 'claude-opus-5',
        snapshotModelId: 'claude-opus-5',
        aliases: [],
        displayName: 'Claude Opus 5',
        family: 'claude-opus-5',
        description: 'Previous Anthropic Opus model retained for compatibility with Claude Opus 5 deployments.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-opus-5-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-05',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: 6.25,
            cacheWrite1hUsdPerMillionTokens: 10,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context window is included at standard pricing. Thinking is enabled by default, and effort supports low, medium, high, xhigh, and max.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('opus-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_OPUS_5_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'coding', 'agent', 'compatibility'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-opus-4-8',
        provider: 'anthropic',
        modelId: 'claude-opus-4-8',
        snapshotModelId: 'claude-opus-4-8',
        aliases: [],
        displayName: 'Claude Opus 4.8',
        family: 'claude-opus-4',
        description: 'Anthropic Opus-tier model for complex reasoning, long-horizon agentic coding, and high-autonomy work.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-opus-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: 6.25,
            cacheWrite1hUsdPerMillionTokens: 10,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context window is included at standard pricing on the Claude API, Amazon Bedrock, and Vertex AI; Microsoft Foundry is listed as 200k.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('opus-4-8'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_FABLE_5_SOURCE,
            ANTHROPIC_MIGRATION_GUIDE_SOURCE,
            ANTHROPIC_OPUS_4_8_SOURCE,
            ANTHROPIC_OPUS_5_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'coding', 'agent', 'compatibility'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-opus-4-7',
        provider: 'anthropic',
        modelId: 'claude-opus-4-7',
        snapshotModelId: 'claude-opus-4-7',
        aliases: [],
        displayName: 'Claude Opus 4.7',
        family: 'claude-opus-4',
        description: 'Previous Anthropic Opus flagship retained for compatibility with Opus 4.7 deployments.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-opus-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: 6.25,
            cacheWrite1hUsdPerMillionTokens: 10,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Pricing in the latest overview is listed as input, output, and caching rates.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('opus-4-7'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_OPUS_4_8_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'coding', 'agent', 'compatibility'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-sonnet-5-5',
        provider: 'anthropic',
        modelId: 'claude-sonnet-5-5',
        snapshotModelId: 'claude-sonnet-5-5',
        aliases: [],
        displayName: 'Claude Sonnet 5.5',
        family: 'claude-sonnet-5-5',
        description: 'Anthropic Sonnet model combining fast inference with adaptive thinking and a one-million-token context window.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: true
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.1,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: 2.5,
            cacheWrite1hUsdPerMillionTokens: 4,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The 1M context window is included at standard pricing. Batch API output can reach 300K tokens with a beta header; this catalog records the standard 128K limit.'
        }),
        sources: [
            createAnthropicModelSource('sonnet-5-5', CURRENT_AUDIT_VERIFIED_AT),
            {
                label: 'Anthropic Claude Sonnet 5.5 migration guide',
                url: 'https://platform.claude.com/docs/en/models/sonnet-5-5/migration-guide',
                verifiedAt: CURRENT_AUDIT_VERIFIED_AT
            },
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['recommended', 'balanced', 'agent', 'analysis'],
        parameterPolicies: {
            temperature: 'unsupported',
            forcedToolChoice: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-sonnet-5',
        provider: 'anthropic',
        modelId: 'claude-sonnet-5',
        snapshotModelId: 'claude-sonnet-5',
        aliases: [],
        displayName: 'Claude Sonnet 5',
        family: 'claude-sonnet-5',
        description: 'Anthropic Sonnet-tier model that upgrades Claude Sonnet 4.6 with stronger speed/intelligence balance.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-5-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 2,
            cachedInputUsdPerMillionTokens: 0.2,
            outputUsdPerMillionTokens: 10,
            cacheWrite5mUsdPerMillionTokens: 2.5,
            cacheWrite1hUsdPerMillionTokens: 4,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'The launch pricing of $2 input, $0.20 cached input, $2.50 5m cache write, $4 1h cache write, and $10 output per MTok is now the standard price; the previously scheduled September 1, 2026 increase will not occur. Full 1M context is included at standard pricing. The new tokenizer can produce about 30% more tokens for the same text compared with Sonnet 4.6.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('sonnet-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_SONNET_5_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'balanced', 'agent', 'analysis'],
        parameterPolicies: {
            temperature: 'unsupported'
        }
    },
    {
        modelKey: 'anthropic:claude-sonnet-4-6',
        provider: 'anthropic',
        modelId: 'claude-sonnet-4-6',
        snapshotModelId: 'claude-sonnet-4-6',
        aliases: [],
        displayName: 'Claude Sonnet 4.6',
        family: 'claude-sonnet-4',
        description: 'Balanced Anthropic model combining strong reasoning with lower latency and cost than Opus.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-08',
        pricing: createPricing({
            inputUsdPerMillionTokens: 3,
            cachedInputUsdPerMillionTokens: 0.3,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: 3.75,
            cacheWrite1hUsdPerMillionTokens: 6,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextCacheWrite5mUsdPerMillionTokens: null,
            longContextCacheWrite1hUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: 'Full 1M context window is included at standard pricing.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('sonnet-4-6'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['legacy', 'balanced', 'agent', 'analysis', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-haiku-5-5',
        provider: 'anthropic',
        modelId: 'claude-haiku-5-5',
        snapshotModelId: 'claude-haiku-5-5',
        aliases: [],
        displayName: 'Claude Haiku 5.5',
        family: 'claude-haiku-5-5',
        description: 'Anthropic’s fastest model for high-volume classification, extraction, and routing, with adaptive thinking.',
        status: 'active',
        recommendedReplacementModelKey: null,
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false,
            requiresAdaptiveThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2026-06',
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.1,
            cachedInputUsdPerMillionTokens: 0.01,
            outputUsdPerMillionTokens: 0.5,
            cacheWrite5mUsdPerMillionTokens: 0.125,
            cacheWrite1hUsdPerMillionTokens: 0.2,
            longContextThresholdInputTokens: 100_000,
            longContextInputUsdPerMillionTokens: 0.5,
            longContextCachedInputUsdPerMillionTokens: 0.05,
            longContextCacheWrite5mUsdPerMillionTokens: 0.625,
            longContextCacheWrite1hUsdPerMillionTokens: 1,
            longContextOutputUsdPerMillionTokens: 2.5,
            notes: 'Prompts over 100K total input tokens, including cache reads and writes, use the higher prices for the full request. The newer tokenizer counts approximately 30% more tokens than Haiku 4.5. Batch API output can reach 300K with a beta header; this catalog records the standard 128K limit.'
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('haiku-5-5', CURRENT_AUDIT_VERIFIED_AT),
            {
                label: 'Anthropic Claude Haiku 5.5 migration guide',
                url: 'https://platform.claude.com/docs/en/models/haiku-5-5/migration-guide',
                verifiedAt: CURRENT_AUDIT_VERIFIED_AT
            },
            {
                label: 'Anthropic thinking modes',
                url: 'https://platform.claude.com/docs/en/build-with-claude/thinking',
                verifiedAt: CURRENT_AUDIT_VERIFIED_AT
            },
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            {
                label: 'Anthropic Models API capabilities',
                url: 'https://api.anthropic.com/v1/models',
                verifiedAt: CURRENT_AUDIT_VERIFIED_AT
            },
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE
        ],
        tags: ['recommended', 'fast', 'cheap', 'title', 'classification'],
        parameterPolicies: {
            temperature: 'unsupported',
            forcedToolChoice: 'supported'
        }
    },
    {
        modelKey: 'anthropic:claude-haiku-4-5',
        provider: 'anthropic',
        modelId: 'claude-haiku-4-5-20251001',
        snapshotModelId: 'claude-haiku-4-5-20251001',
        aliases: ['claude-haiku-4-5'],
        displayName: 'Claude Haiku 4.5',
        family: 'claude-haiku-4',
        description: 'Legacy Anthropic Haiku model retained for compatibility while moving lightweight workloads to Haiku 5.5.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-haiku-5-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: false,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 64_000,
        knowledgeCutoff: '2025-02',
        pricing: createPricing({
            inputUsdPerMillionTokens: 1,
            cachedInputUsdPerMillionTokens: 0.1,
            outputUsdPerMillionTokens: 5,
            cacheWrite5mUsdPerMillionTokens: 1.25,
            cacheWrite1hUsdPerMillionTokens: 2,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('haiku-4-5'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_IDS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE
        ],
        tags: ['legacy', 'fast', 'cheap', 'chat']
    },
    {
        modelKey: 'anthropic:claude-opus-4-5-20251101',
        provider: 'anthropic',
        modelId: 'claude-opus-4-5-20251101',
        snapshotModelId: 'claude-opus-4-5-20251101',
        aliases: ['claude-opus-4-5'],
        displayName: 'Claude Opus 4.5 (20251101)',
        family: 'claude-opus-4',
        description: 'Legacy Anthropic Opus 4.5 snapshot retained for compatibility with existing Opus 4.5 deployments.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-opus-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: false,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 64_000,
        knowledgeCutoff: '2025-05',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: 6.25,
            cacheWrite1hUsdPerMillionTokens: 10,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE,
            createAnthropicModelSource('opus-4-5'),
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-sonnet-4-5-20250929',
        provider: 'anthropic',
        modelId: 'claude-sonnet-4-5-20250929',
        snapshotModelId: 'claude-sonnet-4-5-20250929',
        aliases: ['claude-sonnet-4-5'],
        displayName: 'Claude Sonnet 4.5 (20250929)',
        family: 'claude-sonnet-4',
        description: 'Deprecated Anthropic Sonnet 4.5 snapshot retained for compatibility with existing Sonnet 4.5 deployments.',
        status: 'deprecated',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-5-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: false,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 64_000,
        knowledgeCutoff: '2025-01',
        pricing: createPricing({
            inputUsdPerMillionTokens: 3,
            cachedInputUsdPerMillionTokens: 0.3,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: 3.75,
            cacheWrite1hUsdPerMillionTokens: 6,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            createAnthropicModelSource('sonnet-4-5'),
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_RELEASE_NOTES_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE
        ],
        tags: ['deprecated', 'balanced', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-opus-4-6',
        provider: 'anthropic',
        modelId: 'claude-opus-4-6',
        snapshotModelId: 'claude-opus-4-6',
        aliases: [],
        displayName: 'Claude Opus 4.6',
        family: 'claude-opus-4',
        description: 'Legacy Anthropic flagship retained for compatibility while moving to Opus 5.',
        status: 'legacy',
        recommendedReplacementModelKey: 'anthropic:claude-opus-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: true,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: true,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: true,
            supportsBetweenToolsThinking: false
        }),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
        knowledgeCutoff: '2025-05',
        pricing: createPricing({
            inputUsdPerMillionTokens: 5,
            cachedInputUsdPerMillionTokens: 0.5,
            outputUsdPerMillionTokens: 25,
            cacheWrite5mUsdPerMillionTokens: 6.25,
            cacheWrite1hUsdPerMillionTokens: 10,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [
            ANTHROPIC_MODELS_API_SOURCE,
            ANTHROPIC_COMPUTER_USE_SOURCE,
            createAnthropicModelSource('opus-4-6'),
            ANTHROPIC_MODELS_SOURCE,
            ANTHROPIC_MODEL_DEPRECATIONS_SOURCE,
            ANTHROPIC_PRICING_SOURCE,
            ANTHROPIC_ADAPTIVE_THINKING_SOURCE,
            ANTHROPIC_STRUCTURED_OUTPUTS_SOURCE,
            ANTHROPIC_WEB_SEARCH_SOURCE
        ],
        tags: ['legacy', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-opus-4-1-20250805',
        provider: 'anthropic',
        modelId: 'claude-opus-4-1-20250805',
        snapshotModelId: 'claude-opus-4-1-20250805',
        aliases: [],
        displayName: 'Claude Opus 4.1 (20250805)',
        family: 'claude-opus-4',
        description: 'Retired Anthropic Opus 4.1 snapshot retained for compatibility (requests now error on the Claude API).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-opus-4-8',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 15,
            cachedInputUsdPerMillionTokens: 1.5,
            outputUsdPerMillionTokens: 75,
            cacheWrite5mUsdPerMillionTokens: 18.75,
            cacheWrite1hUsdPerMillionTokens: 30,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_PRICING_SOURCE, ANTHROPIC_RELEASE_NOTES_SOURCE, ANTHROPIC_OPUS_4_8_SOURCE],
        tags: ['retired', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-opus-4-20250514',
        provider: 'anthropic',
        modelId: 'claude-opus-4-20250514',
        snapshotModelId: 'claude-opus-4-20250514',
        aliases: ['claude-opus-4'],
        displayName: 'Claude Opus 4 (20250514)',
        family: 'claude-opus-4',
        description: 'Retired Anthropic Opus 4 snapshot retained for compatibility (requests now error on the Claude API).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-opus-4-8',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 15,
            cachedInputUsdPerMillionTokens: 1.5,
            outputUsdPerMillionTokens: 75,
            cacheWrite5mUsdPerMillionTokens: 18.75,
            cacheWrite1hUsdPerMillionTokens: 30,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_PRICING_SOURCE, ANTHROPIC_RELEASE_NOTES_SOURCE],
        tags: ['retired', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-sonnet-4-20250514',
        provider: 'anthropic',
        modelId: 'claude-sonnet-4-20250514',
        snapshotModelId: 'claude-sonnet-4-20250514',
        aliases: ['claude-sonnet-4'],
        displayName: 'Claude Sonnet 4 (20250514)',
        family: 'claude-sonnet-4',
        description: 'Retired Anthropic Sonnet 4 snapshot retained for compatibility (requests now error on the Claude API).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-4-6',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: null,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: null,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 3,
            cachedInputUsdPerMillionTokens: 0.3,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: 3.75,
            cacheWrite1hUsdPerMillionTokens: 6,
            longContextThresholdInputTokens: 200_000,
            longContextInputUsdPerMillionTokens: 6,
            longContextCachedInputUsdPerMillionTokens: 0.6,
            longContextCacheWrite5mUsdPerMillionTokens: 7.5,
            longContextCacheWrite1hUsdPerMillionTokens: 12,
            longContextOutputUsdPerMillionTokens: 22.5,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_PRICING_SOURCE, ANTHROPIC_RELEASE_NOTES_SOURCE],
        tags: ['retired', 'balanced', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-3-haiku-20240307',
        provider: 'anthropic',
        modelId: 'claude-3-haiku-20240307',
        snapshotModelId: 'claude-3-haiku-20240307',
        aliases: ['claude-3-haiku', 'claude-3-haiku-latest'],
        displayName: 'Claude Haiku 3 (20240307)',
        family: 'claude-haiku-3',
        description: 'Retired Anthropic Haiku 3 snapshot retained for compatibility (requests now error).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-haiku-4-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: null,
        maxOutputTokens: null,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.25,
            cachedInputUsdPerMillionTokens: 0.03,
            outputUsdPerMillionTokens: 1.25,
            cacheWrite5mUsdPerMillionTokens: 0.3,
            cacheWrite1hUsdPerMillionTokens: 0.5,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_PRICING_SOURCE],
        tags: ['retired', 'cheap', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-3-7-sonnet-20250219',
        provider: 'anthropic',
        modelId: 'claude-3-7-sonnet-20250219',
        snapshotModelId: 'claude-3-7-sonnet-20250219',
        aliases: ['claude-3-7-sonnet', 'claude-3-7-sonnet-latest'],
        displayName: 'Claude Sonnet 3.7 (20250219)',
        family: 'claude-sonnet-3.7',
        description: 'Retired Anthropic reasoning model retained for compatibility (requests now error).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-4-6',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: true,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 64_000,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 3,
            cachedInputUsdPerMillionTokens: 0.3,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: 3.75,
            cacheWrite1hUsdPerMillionTokens: 6,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_MODELS_SOURCE, ANTHROPIC_PRICING_SOURCE],
        tags: ['retired', 'reasoning', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-3-5-sonnet-20241022',
        provider: 'anthropic',
        modelId: 'claude-3-5-sonnet-20241022',
        snapshotModelId: 'claude-3-5-sonnet-20241022',
        aliases: ['claude-3-5-sonnet', 'claude-3-5-sonnet-latest'],
        displayName: 'Claude Sonnet 3.5 (20241022)',
        family: 'claude-sonnet-3.5',
        description: 'Retired Anthropic Sonnet 3.5 snapshot retained for compatibility (requests now error).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-sonnet-4-6',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 8_192,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 3,
            cachedInputUsdPerMillionTokens: 0.3,
            outputUsdPerMillionTokens: 15,
            cacheWrite5mUsdPerMillionTokens: 3.75,
            cacheWrite1hUsdPerMillionTokens: 6,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_MODELS_SOURCE, ANTHROPIC_PRICING_SOURCE],
        tags: ['retired', 'balanced', 'compatibility']
    },
    {
        modelKey: 'anthropic:claude-3-5-haiku-20241022',
        provider: 'anthropic',
        modelId: 'claude-3-5-haiku-20241022',
        snapshotModelId: 'claude-3-5-haiku-20241022',
        aliases: ['claude-3-5-haiku', 'claude-3-5-haiku-latest'],
        displayName: 'Claude Haiku 3.5 (20241022)',
        family: 'claude-haiku-3.5',
        description: 'Retired Anthropic Haiku 3.5 snapshot retained for compatibility (requests now error).',
        status: 'retired',
        recommendedReplacementModelKey: 'anthropic:claude-haiku-4-5',
        inputModalities: ['text', 'image'],
        outputModalities: ['text'],
        capabilities: createCapabilities({
            supportsTextInput: true,
            supportsTextOutput: true,
            supportsImageInput: true,
            supportsAudioInput: false,
            supportsAudioOutput: false,
            supportsVision: true,
            supportsStreaming: true,
            supportsToolCalling: true,
            supportsStructuredOutputs: null,
            supportsPromptCaching: true,
            supportsWebSearch: true,
            supportsFileSearch: null,
            supportsComputerUse: null,
            supportsMcp: null,
            supportsReasoningEffort: false,
            reasoningEffortLevels: [],
            supportsExtendedThinking: false,
            supportsAdaptiveThinking: null
        }),
        contextWindowTokens: 200_000,
        maxOutputTokens: 8_192,
        knowledgeCutoff: null,
        pricing: createPricing({
            inputUsdPerMillionTokens: 0.8,
            cachedInputUsdPerMillionTokens: 0.08,
            outputUsdPerMillionTokens: 4,
            cacheWrite5mUsdPerMillionTokens: 1,
            cacheWrite1hUsdPerMillionTokens: 1.6,
            longContextThresholdInputTokens: null,
            longContextInputUsdPerMillionTokens: null,
            longContextCachedInputUsdPerMillionTokens: null,
            longContextOutputUsdPerMillionTokens: null,
            notes: null
        }),
        sources: [ANTHROPIC_MODEL_DEPRECATIONS_SOURCE, ANTHROPIC_MODELS_SOURCE, ANTHROPIC_PRICING_SOURCE],
        tags: ['retired', 'cheap', 'compatibility']
    }
];
//# sourceMappingURL=aiModelCatalog.js.map